export default __webpack_public_path__ + "static/media/ChronicleSSm-Medium_Web.8687de72.woff";